<div>
  <span>{{message}}</span>
</div>